import api from "./Api";

class StUfService {
  GetStUf(payload) {
    return api.get("/v1/stUf/" + payload).then((response) => {
      return response.data;
    });
  }

  PostStUf(payload) {
    return api.post("/v1/stUf/", payload).then((response) => {
      return response.data;
    });
  }

  PutStUf(payload) {
    return api.put("/v1/stUf/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteStUf(payload) {
    return api.delete("/v1/stUf/" + payload).then((response) => {
      return response.data;
    });
  }

  GetStUfOData(payload) {
    return api.get("/OData/StUf" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new StUfService();
